import axios from 'axios';
import moment from 'moment';
import { Component } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import { Redirect } from 'react-router-dom';
import { DateTimeFormat } from "./DateFormat/DateTimeFormat";
import CommonLoader from './loaderComponent/CommonLoader';

export default class EmployeeView extends Component {
	constructor(props) {
		super(props);

		this.state = {
			user: {},
			department: {
				departmentName: null
			},
			job: [{
				jobTitle: null,
				startDate: null,
				endDate: null
			}],
			userPersonalInfo: {
				dateOfBirth: null,
				gender: null,
				maritalStatus: null,
				fatherName: null,
				country: null,
				state: null,
				address: null,
				mobile: null,
				emailAddress: null
			},
			userFinancialInfo: {
				bankName: null,
				accountName: null,
				accountNumber: null,
				iban: null,
				otstatus: null,
				esicStatus: null
			},
			employee: {
				emailAddress: null,
				Aadhaar_number: null,
				pan_number: "",
				esic_number: "",
				pf_number: "",
				nominee_name: "",
				nominee_relation: "",
			},
			falseRedirect: false,
			editRedirect: false,
			listRedirect: false,
			profileImage: '',
			userID: '',
			loading: true
		};
	}


	// documents/profile/: employeeId
	componentDidMount() {
		this.setState({ loading: true });
		if (this.props.location.state) {
			axios({
				method: 'get',
				url: 'users/' + this.props.location.state.selectedUser.id,
				headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
			})
				.then(res => {
					let user = res.data;
					this.setState({ user: user, loading: false }, () => {
						if (user.jobs) {
							let jobs = user.jobs;
							console.log("jobs--->", jobs);
							this.setState({ job: jobs });
							// jobs.map(job => {
							// 	// if (new Date(job.startDate) <= Date.now() && new Date(job.endDate) >= Date.now()) {
							// 	this.setState({ job: job })
							// 	// }
							// })
						}
						if (user.department) {
							this.setState({ department: user.department });

						}
						if (user.user_personal_info) {
							if (user.user_personal_info.dateOfBirth) {
								this.fetchEmployeeProfile(user.user_personal_info.userId);
								user.user_personal_info.dateOfBirth = moment(user.user_personal_info.dateOfBirth).format('D MMM YYYY');
							}
							this.setState({ userPersonalInfo: user.user_personal_info });

						}
						if (user.user_financial_info) {
							this.setState({ userFinancialInfo: user.user_financial_info });
						}
						if (user.employee) {
							this.setState({ employee: user.employee });
						}

					});
				})

				.catch(err => {
					this.setState({ loading: false });
					console.log(err);
				});
		} else {
			this.setState({ loading: false });
			this.setState({ falseRedirect: true });
		}
	}

	fetchEmployeeProfile = (id) => {
		this.setState({ loading: true });
		axios({
			method: 'get',
			url: `document/profile/${id}`,
			headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
		})
			.then(res => {
				this.setState({ profileImage: res.data.profileImage, loading: false });
			})

			.catch(err => {
				this.setState({ loading: false });
			});
	};

	onEdit = (user) => {
		console.log("user", user);
		// this.props.history.push('/employee-edit')
		this.setState({ editRedirect: true, loading: false });
	};
	onEmployeeList = () => {
		this.setState({ listRedirect: true, loading: false });
	};



	render() {
		return (
			<div className="pt-4">
				<CommonLoader isLoading={this.state.loading}>

					{this.state.falseRedirect ? <Redirect to="/" /> : (<></>)}
					{this.state.editRedirect ? (<Redirect to={{ pathname: "/employee-edit", state: { selectedUser: this.state.user } }} />) : null}
					{this.state.listRedirect ? (<Redirect to={{ pathname: "/employee-list", state: {} }} />) : null}
					< >
						<Row>
							<Col sm={12}>
								<Card className="shadow-sm rounded border-0">
									<Card.Header
										style={{ backgroundColor: "#515e73", color: "white", fontSize: '17px' }}>Employee Detail
										<Form className="float-right">
											<div className="emp-view-page">
												<span style={{ cursor: 'pointer' }} onClick={() => this.onEdit(this.state.user)}>
													<i className="far fa-edit"> Edit</i></span>
												<span style={{ cursor: 'pointer' }} onClick={() => this.onEmployeeList()}>
													<i className="far fa-arrow-alt-circle-right"> Employee List</i> </span>
											</div>
										</Form>
									</Card.Header>
									<Card.Body>
										<Card.Title><strong>{this.state.user.fullName}</strong></Card.Title>
										<>
											<Col lg={12}>
												<Row className="pt-4 align-items-center">
													<Col lg={3} className="text-center">
														<img
															className="img-fluid rounded-circle shadow-sm"
															src={
																this.state.profileImage
																	? `${process.env.REACT_APP_BACKEND_URL}/${this.state.profileImage}`
																	: process.env.PUBLIC_URL + "/user-128.png"
															}
															alt="profile"
															style={{ width: "120px", height: "120px", objectFit: "cover" }}
														/>
													</Col>
													<Col lg={9} className="pt-3">
														<div className="emp-view-list p-3 border rounded shadow-sm bg-light">
															<ul className="list-unstyled mb-0">
																<li className="mb-2"><strong>Employee ID:</strong> {this.state.user.id}</li>
																<li className="mb-2"><strong>Department:</strong> {this.state.department.departmentName}</li>
																<ul>
																	{this.state.job.map((job, index) => (
																		<li key={index} className="mb-2">
																			<strong>Job Title:</strong> {job.jobTitle}
																		</li>
																	))}
																</ul>
																{/* <li className="mb-2"><strong>Job Title:</strong> {this.state.job.jobTitle}</li> */}
																<li className="mb-2"><strong>Role:</strong>
																	{this.state.user.role === 'ROLE_ADMIN' ? ' Admin' :
																		this.state.user.role === 'ROLE_MANAGER' ? ' Manager' : ' Employee'}
																</li>
																<li className="mb-2"><strong>Report To: </strong>
																	{/* {this.state.user?.reportid} */}
																	{this.state.user?.reportingUser?.fullName || this.state.user?.reportid}
																</li>
																<li className="mb-2"><strong>Advance Salary: </strong>
																	{this.state.userFinancialInfo?.salaryBalance}
																</li>
																<li className="mb-2"><strong>Trip Balance: </strong>
																	{this.state.userFinancialInfo?.tripBalance}
																</li>
															</ul>
														</div>
													</Col>
												</Row>

												<Row>
													<Col sm={6}>
														<Card className="secondary-card emp-view shadow-sm rounded border-0">
															<Card.Header>Personal Details</Card.Header>
															<Card.Body>
																<span id="emp-view-personal">
																	<div className="d-flex justify-content-between">
																		<strong>Date of Birth:</strong>
																		<span>{this.state.userPersonalInfo.dateOfBirth}</span>
																	</div>
																	<div className="d-flex justify-content-between">
																		<strong>Gender:</strong>
																		<span>{this.state.userPersonalInfo.gender}</span>
																	</div>
																	<div className="d-flex justify-content-between">
																		<strong>Marital Status:</strong>
																		<span>{this.state.userPersonalInfo.maritalStatus}</span>
																	</div>
																	<div className="d-flex justify-content-between">
																		<strong>Father's Name:</strong>
																		<span>{this.state.userPersonalInfo.fatherName}</span>
																	</div>
																</span>
															</Card.Body>
														</Card>

													</Col>
													<Col sm={6}>
														<Card className="secondary-card emp-view shadow-sm rounded border-0">
															<Card.Header>Contact Details</Card.Header>
															<Card.Body>
																<span id="emp-view-contact">
																	<div className="d-flex justify-content-between">
																		<strong>Location:</strong>
																		<span>{this.state.userPersonalInfo.city},{this.state.userPersonalInfo.state}, {this.state.userPersonalInfo.country}</span>
																	</div>
																	<div className="d-flex justify-content-between">
																		<strong>Address:</strong>
																		<span>{this.state.userPersonalInfo.address}</span>
																	</div>
																	<div className="d-flex justify-content-between">
																		<strong>Mobile:</strong>
																		<span>
																			{this.state.userPersonalInfo.mobile}
																			{this.state.userPersonalInfo.phone ? (' (' + this.state.userPersonalInfo.phone + ')') : null}
																		</span>
																	</div>
																	<div className="d-flex justify-content-between">
																		<strong>Email Address:</strong>
																		<span>{this.state.userPersonalInfo.emailAddress}</span>
																	</div>
																</span>
															</Card.Body>
														</Card>
													</Col>
												</Row>
												<Row>
													<Col cm={6}>
														<Card className="secondary-card shadow-sm rounded border-0">
															<Card.Header>Bank Information</Card.Header>
															<Card.Body>
																<span id="emp-view-bank">
																	<div className="d-flex justify-content-between">
																		<strong>Bank Name:</strong>
																		<span>{this.state.userFinancialInfo.bankName}</span>
																	</div>
																	<div className="d-flex justify-content-between">
																		<strong>Account Name:</strong>
																		<span>{this.state.userFinancialInfo.accountName}</span>
																	</div>
																	<div className="d-flex justify-content-between">
																		<strong>Account Number:</strong>
																		<span>{this.state.userFinancialInfo.accountNumber}</span>
																	</div>
																	<div className="d-flex justify-content-between">
																		<strong>IFSC Code:</strong>
																		<span>{this.state.userFinancialInfo.iban}</span>
																	</div>
																</span>
															</Card.Body>
														</Card>

													</Col>
													<Col sm={6}>
														<Card className="secondary-card shadow-sm rounded border-0">
															<Card.Header>Documents Information</Card.Header>
															<Card.Body>
																<span id="emp-view-bank">
																	<div className="d-flex justify-content-between">
																		<strong>Aaadhar Number:</strong>
																		<span>{this.state.employee.Aadhaar_number}</span>
																	</div>
																	<div className="d-flex justify-content-between">
																		<strong>PAN Number:</strong>
																		<span>{this.state.employee.pan_number}</span>
																	</div>
																	<div className="d-flex justify-content-between">
																		<strong>ECIS Number:</strong>
																		<span>{this.state.employee.esic_number}</span>
																	</div>
																	<div className="d-flex justify-content-between">
																		<strong>PF Number:</strong>
																		<span>{this.state.employee.pf_number}</span>
																	</div>
																	<div className="d-flex justify-content-between">
																		<strong>ESIC Status:</strong>
																		<span>{this.state.userFinancialInfo.esicStatus}</span>
																	</div>
																</span>
															</Card.Body>
														</Card>
													</Col>
												</Row>

												{/* details--added */}
												<Row>
													<Col cm={6}>
														<Card className="secondary-card shadow-sm rounded border-0">
															<Card.Header>Nominee Details</Card.Header>
															<Card.Body>
																<span id='emp-view-nominee-details'>
																	<div className="d-flex justify-content-between">
																		<strong>Nominee Name:</strong>
																		<span>{this.state.employee.nominee_name}</span>
																	</div>
																	<div className="d-flex justify-content-between">
																		<strong>Relation with Nominee:</strong>
																		<span>{this.state.employee.nominee_relation}</span>
																	</div>

																</span>
															</Card.Body>
														</Card>
													</Col>
													<Col sm={6}>
														{this.state.job.map((job, index) => (
															<Card key={index} className="secondary-card nominee-card shadow-sm rounded border-0">
																<Card.Header>Job Details</Card.Header>
																<Card.Body key={index}>
																	<span id='emp-view-Job-details'>
																		<div className="d-flex justify-content-between">
																			<strong>Title:</strong>
																			<span>{job?.jobTitle}</span>
																		</div>
																		<div className="d-flex justify-content-between">
																			<strong>Start Date:</strong>
																			<span>{DateTimeFormat(job?.startDate)}</span>
																		</div>
																		<div className="d-flex justify-content-between">
																			<strong>End Date:</strong>
																			<span>{job?.endDate ? DateTimeFormat(job.endDate) : 'N/A'}</span>
																		</div>

																	</span>
																</Card.Body>
															</Card>
														))}
													</Col>
												</Row>
												<Row>
													<Col sm={3}>
														<Card className="secondary-card h-100 shadow-sm rounded border-0">
															<Card.Header>Salary Details</Card.Header>
															<Card.Body>
																<span id='emp-view-Salary-details'>
																	<div className="d-flex justify-content-between">
																		<strong> Overtime Status:</strong>
																		<span>{this.state.userFinancialInfo.otStatus}</span>
																	</div>
																	<div className="d-flex justify-content-between">
																		<strong> Working Hours:</strong>
																		<span>{this.state.userFinancialInfo.OtWorkingHours} </span>
																	</div>
																	<div className="d-flex justify-content-between">
																		<strong>Employment Type:</strong>
																		<span>{this.state.userFinancialInfo.employmentType}</span>
																	</div>
																	<div className="d-flex justify-content-between">
																		<strong>Basic Salary:</strong>
																		<span>{this.state.userFinancialInfo.salaryBasic}</span>
																	</div>
																</span>
															</Card.Body>
														</Card>
													</Col>

													<Col sm={3}>
														<Card className="secondary-card h-100 shadow-sm rounded border-0">
															<Card.Header>Allowances Details</Card.Header>
															<Card.Body>
																<span id='emp-view-allowances-details'>
																	<div className="d-flex justify-content-between">
																		<strong>House Rent Allowance:</strong>
																		<span>{this.state.userFinancialInfo.allowanceHouseRent}</span>
																	</div>
																	<div className="d-flex justify-content-between">
																		<strong>Medical Allowance:</strong>
																		<span>{this.state.userFinancialInfo.allowanceMedical}</span>
																	</div>
																	<div className="d-flex justify-content-between">
																		<strong>Special Allowance:</strong>
																		<span>{this.state.userFinancialInfo.allowanceSpecial}</span>
																	</div>
																	<div className="d-flex justify-content-between">
																		<strong>Fuel Allowance:</strong>
																		<span>{this.state.userFinancialInfo.allowanceFuel}</span>
																	</div>
																	<div className="d-flex justify-content-between">
																		<strong>Food Allowance:</strong>
																		<span>{this.state.userFinancialInfo.allowancePhoneBill}</span>
																	</div>
																	<div className="d-flex justify-content-between">
																		<strong>Other Expenses:</strong>
																		<span>{this.state.userFinancialInfo.allowanceOther}</span>
																	</div>
																</span>
															</Card.Body>
														</Card>
													</Col>

													<Col sm={3}>
														<Card className="secondary-card h-100 shadow-sm rounded border-0">
															<Card.Header>Deductions  Details</Card.Header>
															<Card.Body>
																<span id='emp-view-deduction-details'>
																	<div className="d-flex justify-content-between">
																		<strong>PF Deduction:</strong>
																		<span>{this.state.userFinancialInfo.deductionProvidentFund}</span>
																	</div>
																	<div className="d-flex justify-content-between">
																		<strong>Tax Deduction:</strong>
																		<span>{this.state.userFinancialInfo.deductionTax}</span>
																	</div>
																	<div className="d-flex justify-content-between">
																		<strong>Other Deduction:</strong>
																		<span>{this.state.userFinancialInfo.deductionOther}</span>
																	</div>
																</span>
															</Card.Body>
														</Card>
													</Col>
													<Col sm={3}>
														<Card className="secondary-card h-100 shadow-sm rounded border-0">
															<Card.Header>Total Salary Details</Card.Header>
															<Card.Body>
																<span id='emp-view-salary-details'>
																	<div className="d-flex justify-content-between">
																		<strong>Gross Salary:</strong>
																		<span>{this.state.userFinancialInfo.salaryGross}</span>
																	</div>
																	<div className="d-flex justify-content-between">
																		<strong>Total Deductions:</strong>
																		<span>{this.state.userFinancialInfo.deductionTotal}</span>
																	</div>
																	<div className="d-flex justify-content-between">
																		<strong>Net Salary:</strong>
																		<span>{this.state.userFinancialInfo.salaryNet}</span>
																	</div>

																</span>
															</Card.Body>
														</Card>
													</Col>
												</Row>
												{/* details--added */}
											</Col>
										</>
									</Card.Body>
								</Card>
							</Col>
						</Row>
					</>


				</CommonLoader >
			</div>

		);
	}
}